import TipTapDisplay from "@/components/TipTapDisplay/TipTapDisplay";

export default {
  name: "workOrderInstructions",
  components: {
    TipTapDisplay,
  },
  data() {
    return {};
  },
  computed: {
    workOrderInstructions: function() {
      return this.$store.getters.workOrderInstructions;
    },
    workOrder: function() {
      return this.$store.getters.workOrder;
    },
  },
};
